// extracted by mini-css-extract-plugin
export default {"wrapper":"Cover_wrapper__HrQpQ","cover":"Cover_cover__2PHNC","card":"Cover_card__DXMt5","price":"Cover_price__y27dM"};